import { putAttribute } from "@/common/character/attributes";

export interface AttributesStore {
  agility: number;
  charisma: number;
  health: number;
  intelligence: number;
  perception: number;
  power: number;
  strength: number;
  willpower: number;
  tempAgility: number;
  tempCharisma: number;
  tempHealth: number;
  tempIntelligence: number;
  tempPerception: number;
  tempPower: number;
  tempStrength: number;
  tempWillpower: number;
  agilityId: number;
  charismaId: number;
  healthId: number;
  intelligenceId: number;
  perceptionId: number;
  powerId: number;
  strengthId: number;
  willpowerId: number;
  tempAgilityId: number;
  tempCharismaId: number;
  tempHealthId: number;
  tempIntelligenceId: number;
  tempPerceptionId: number;
  tempPowerId: number;
  tempStrengthId: number;
  tempWillpowerId: number;
}

export default {
  namespaced: true,
  state: (): AttributesStore => ({
    agility: 0,
    charisma: 0,
    health: 0,
    intelligence: 0,
    perception: 0,
    power: 0,
    strength: 0,
    willpower: 0,
    tempAgility: 0,
    tempCharisma: 0,
    tempHealth: 0,
    tempIntelligence: 0,
    tempPerception: 0,
    tempPower: 0,
    tempStrength: 0,
    tempWillpower: 0,
    agilityId: 0,
    charismaId: 0,
    healthId: 0,
    intelligenceId: 0,
    perceptionId: 0,
    powerId: 0,
    strengthId: 0,
    willpowerId: 0,
    tempAgilityId: 0,
    tempCharismaId: 0,
    tempHealthId: 0,
    tempIntelligenceId: 0,
    tempPerceptionId: 0,
    tempPowerId: 0,
    tempStrengthId: 0,
    tempWillpowerId: 0,
  }),
  getters: {
    agility: (state: AttributesStore) => {
      return state.agility;
    },
    charisma: (state: AttributesStore) => {
      return state.charisma;
    },
    health: (state: AttributesStore) => {
      return state.health;
    },
    intelligence: (state: AttributesStore) => {
      return state.intelligence;
    },
    perception: (state: AttributesStore) => {
      return state.perception;
    },
    power: (state: AttributesStore) => {
      return state.power;
    },
    strength: (state: AttributesStore) => {
      return state.strength;
    },
    willpower: (state: AttributesStore) => {
      return state.willpower;
    },
    tempAgility: (state: AttributesStore) => {
      return state.tempAgility;
    },
    tempCharisma: (state: AttributesStore) => {
      return state.tempCharisma;
    },
    tempHealth: (state: AttributesStore) => {
      return state.tempHealth;
    },
    tempIntelligence: (state: AttributesStore) => {
      return state.tempIntelligence;
    },
    tempPerception: (state: AttributesStore) => {
      return state.tempPerception;
    },
    tempPower: (state: AttributesStore) => {
      return state.tempPower;
    },
    tempStrength: (state: AttributesStore) => {
      return state.tempStrength;
    },
    tempWillpower: (state: AttributesStore) => {
      return state.tempWillpower;
    },
    agilityId: (state: AttributesStore) => {
      return state.agilityId;
    },
    charismaId: (state: AttributesStore) => {
      return state.charismaId;
    },
    healthId: (state: AttributesStore) => {
      return state.healthId;
    },
    intelligenceId: (state: AttributesStore) => {
      return state.intelligenceId;
    },
    perceptionId: (state: AttributesStore) => {
      return state.perceptionId;
    },
    powerId: (state: AttributesStore) => {
      return state.powerId;
    },
    strengthId: (state: AttributesStore) => {
      return state.strengthId;
    },
    willpowerId: (state: AttributesStore) => {
      return state.willpowerId;
    },
    tempAgilityId: (state: AttributesStore) => {
      return state.tempAgilityId;
    },
    tempCharismaId: (state: AttributesStore) => {
      return state.tempCharismaId;
    },
    tempHealthId: (state: AttributesStore) => {
      return state.tempHealthId;
    },
    tempIntelligenceId: (state: AttributesStore) => {
      return state.tempIntelligenceId;
    },
    tempPerceptionId: (state: AttributesStore) => {
      return state.tempPerceptionId;
    },
    tempPowerId: (state: AttributesStore) => {
      return state.tempPowerId;
    },
    tempStrengthId: (state: AttributesStore) => {
      return state.tempStrengthId;
    },
    tempWillpowerId: (state: AttributesStore) => {
      return state.tempWillpowerId;
    },
    totalAttributes: (state: AttributesStore) => {
      return (
        state.strength +
        state.agility +
        state.health +
        state.intelligence +
        state.perception +
        state.willpower +
        state.power +
        state.charisma
      );
    },
    attributes: (state: AttributesStore) => {
      return {
        agility: state.agility,
        charisma: state.charisma,
        health: state.health,
        intelligence: state.intelligence,
        perception: state.perception,
        power: state.power,
        strength: state.strength,
        willpower: state.willpower,
        tempAgility: state.tempAgility,
        tempCharisma: state.tempCharisma,
        tempHealth: state.tempHealth,
        tempIntelligence: state.tempIntelligence,
        tempPerception: state.tempPerception,
        tempPower: state.tempPower,
        tempStrength: state.tempStrength,
        tempWillpower: state.tempWillpower,
      };
    },
  },
  mutations: {
    setAttributes: (
      state: AttributesStore,
      newData: {
        agility: number;
        charisma: number;
        health: number;
        intelligence: number;
        perception: number;
        power: number;
        strength: number;
        willpower: number;
        tempAgility: number;
        tempCharisma: number;
        tempHealth: number;
        tempIntelligence: number;
        tempPerception: number;
        tempPower: number;
        tempStrength: number;
        tempWillpower: number;
        agilityId: number;
        charismaId: number;
        healthId: number;
        intelligenceId: number;
        perceptionId: number;
        powerId: number;
        strengthId: number;
        willpowerId: number;
        tempAgilityId: number;
        tempCharismaId: number;
        tempHealthId: number;
        tempIntelligenceId: number;
        tempPerceptionId: number;
        tempPowerId: number;
        tempStrengthId: number;
        tempWillpowerId: number;
      }
    ) => {
      state.agility = newData.agility;
      state.charisma = newData.charisma;
      state.health = newData.health;
      state.intelligence = newData.intelligence;
      state.perception = newData.perception;
      state.power = newData.power;
      state.strength = newData.strength;
      state.willpower = newData.willpower;
      state.tempAgility = newData.tempAgility;
      state.tempCharisma = newData.tempCharisma;
      state.tempHealth = newData.tempHealth;
      state.tempIntelligence = newData.tempIntelligence;
      state.tempPerception = newData.tempPerception;
      state.tempPower = newData.tempPower;
      state.tempStrength = newData.tempStrength;
      state.tempWillpower = newData.tempWillpower;
      state.agilityId = newData.agilityId;
      state.charismaId = newData.charismaId;
      state.healthId = newData.healthId;
      state.intelligenceId = newData.intelligenceId;
      state.perceptionId = newData.perceptionId;
      state.powerId = newData.powerId;
      state.strengthId = newData.strengthId;
      state.willpowerId = newData.willpowerId;
      state.tempAgilityId = newData.tempAgilityId;
      state.tempCharismaId = newData.tempCharismaId;
      state.tempHealthId = newData.tempHealthId;
      state.tempIntelligenceId = newData.tempIntelligenceId;
      state.tempPerceptionId = newData.tempPerceptionId;
      state.tempPowerId = newData.tempPowerId;
      state.tempStrengthId = newData.tempStrengthId;
      state.tempWillpowerId = newData.tempWillpowerId;
    },
    setDBAttributes: (
      state: AttributesStore,
      newData: { name: string; value: number; id: number }
    ) => {
      state[newData.name as keyof AttributesStore] = newData.value;
      state[(newData.name + "Id") as keyof AttributesStore] = newData.id;
    },
    setAgility: (state: AttributesStore, newData: number) => {
      state.agility = newData;
    },
    setCharisma: (state: AttributesStore, newData: number) => {
      state.charisma = newData;
    },
    setHealth: (state: AttributesStore, newData: number) => {
      state.health = newData;
    },
    setIntelligence: (state: AttributesStore, newData: number) => {
      state.intelligence = newData;
    },
    setPerception: (state: AttributesStore, newData: number) => {
      state.perception = newData;
    },
    setPower: (state: AttributesStore, newData: number) => {
      state.power = newData;
    },
    setStrength: (state: AttributesStore, newData: number) => {
      state.strength = newData;
    },
    setWillpower: (state: AttributesStore, newData: number) => {
      state.willpower = newData;
    },
    setTempAgility: (state: AttributesStore, newData: number) => {
      state.tempAgility = newData;
    },
    setTempCharisma: (state: AttributesStore, newData: number) => {
      state.tempCharisma = newData;
    },
    setTempHealth: (state: AttributesStore, newData: number) => {
      state.tempHealth = newData;
    },
    setTempIntelligence: (state: AttributesStore, newData: number) => {
      state.tempIntelligence = newData;
    },
    setTempPerception: (state: AttributesStore, newData: number) => {
      state.tempPerception = newData;
    },
    setTempPower: (state: AttributesStore, newData: number) => {
      state.tempPower = newData;
    },
    setTempStrength: (state: AttributesStore, newData: number) => {
      state.tempStrength = newData;
    },
    setTempWillpower: (state: AttributesStore, newData: number) => {
      state.tempWillpower = newData;
    },
  },
  actions: {
    overwriteTemp: (context: any, character_id: string) => {
      context.dispatch("putTempAgility", {
        value: context.getters.agility,
        character_id: character_id,
      });
      context.dispatch("putTempCharisma", {
        value: context.getters.charisma,
        character_id: character_id,
      });
      context.dispatch("putTempHealth", {
        value: context.getters.health,
        character_id: character_id,
      });
      context.dispatch("putTempIntelligence", {
        value: context.getters.intelligence,
        character_id: character_id,
      });
      context.dispatch("putTempPerception", {
        value: context.getters.perception,
        character_id: character_id,
      });
      context.dispatch("putTempPower", {
        value: context.getters.power,
        character_id: character_id,
      });
      context.dispatch("putTempStrength", {
        value: context.getters.strength,
        character_id: character_id,
      });
      context.dispatch("putTempWillpower", {
        value: context.getters.willpower,
        character_id: character_id,
      });
    },
    putAgility: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setAgility", newData.value);
      const push = {
        id: context.getters["agilityId"],
        character_id: newData.character_id,
        name: "agility",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putCharisma: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setCharisma", newData.value);
      const push = {
        id: context.getters["charismaId"],
        character_id: newData.character_id,
        name: "charisma",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putHealth: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setHealth", newData.value);
      const push = {
        id: context.getters["healthId"],
        character_id: newData.character_id,
        name: "health",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putIntelligence: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setIntelligence", newData.value);
      const push = {
        id: context.getters["intelligenceId"],
        character_id: newData.character_id,
        name: "intelligence",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putPerception: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setPerception", newData.value);
      const push = {
        id: context.getters["perceptionId"],
        character_id: newData.character_id,
        name: "perception",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putPower: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setPower", newData.value);
      const push = {
        id: context.getters["powerId"],
        character_id: newData.character_id,
        name: "power",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putStrength: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setStrength", newData.value);
      const push = {
        id: context.getters["strengthId"],
        character_id: newData.character_id,
        name: "strength",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putWillpower: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setWillpower", newData.value);
      const push = {
        id: context.getters["willpowerId"],
        character_id: newData.character_id,
        name: "willpower",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempAgility: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempAgility", newData.value);
      const push = {
        id: context.getters["tempAgilityId"],
        character_id: newData.character_id,
        name: "tempAgility",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempCharisma: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempCharisma", newData.value);
      const push = {
        id: context.getters["tempCharismaId"],
        character_id: newData.character_id,
        name: "tempCharisma",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempHealth: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempHealth", newData.value);
      const push = {
        id: context.getters["tempHealthId"],
        character_id: newData.character_id,
        name: "tempHealth",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempIntelligence: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempIntelligence", newData.value);
      const push = {
        id: context.getters["tempIntelligenceId"],
        character_id: newData.character_id,
        name: "tempIntelligence",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempPerception: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempPerception", newData.value);
      const push = {
        id: context.getters["tempPerceptionId"],
        character_id: newData.character_id,
        name: "tempPerception",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempPower: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempPower", newData.value);
      const push = {
        id: context.getters["tempPowerId"],
        character_id: newData.character_id,
        name: "tempPower",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempStrength: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempStrength", newData.value);
      const push = {
        id: context.getters["tempStrengthId"],
        character_id: newData.character_id,
        name: "tempStrength",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
    putTempWillpower: (
      context: any,
      newData: { value: number; character_id: string }
    ) => {
      context.commit("setTempWillpower", newData.value);
      const push = {
        id: context.getters["tempWillpowerId"],
        character_id: newData.character_id,
        name: "tempWillpower",
        value: newData.value,
      };
      putAttribute(push).then((response) => {
        const attr = {
          name: response.data[0].name,
          value: response.data[0].value,
          id: response.data[0].id,
        };
        context.commit("setDBAttributes", attr);
      });
    },
  },
};
